import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBooking } from 'shared-types/SharedTypes';
import { IActiveBookingsState } from './types';
import { IDiarySchedule } from 'shared-types/DiaryTypes';
import { DiaryRootState } from 'appRoot/rootReducer';
import DateUtilsService from 'external-services/date-utils-service';
import BookingLookupService from 'external-services/booking-lookup-service';
import { orderBy } from 'lodash-es';

const NS = 'activeBookingsSlice';

const initialState: IActiveBookingsState = {
  activeScheduleBookings: [],
};

export const setBookingsForSchedule = createAsyncThunk(
  'activeBookings/setBookingsForSchedule',
  async (payload: void, { dispatch, getState }): Promise<IBooking[]> => {
    const {
      displayReducer: { activeBooking, activeSchedule },
      scheduleReducer: { selectedDate, selectedSchedule },
      bookingReducer: { couchReducedBookings },
    } = getState() as DiaryRootState;

    const dateTime: Date = activeBooking.time;
    const schedule: IDiarySchedule = activeSchedule || selectedSchedule;

    let bookings: IBooking[];
    if (dateTime && DateUtilsService.isOnSameDate(dateTime, selectedDate)) {
      bookings = couchReducedBookings;
    } else {
      try {
        const result = await BookingLookupService.getBySchedule(schedule);
        bookings = orderBy(result.bookings, 'time');
      } catch (err) {
        bookings = [];
        console.warn(
          NS,
          `Error on 'getBookingsByTable' getting bookings. schedule: `,
          schedule,
          err
        );
      }
    }
    return bookings;
  }
);

const activeBookingsSlice = createSlice({
  name: 'activeBookings', // used in action types
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setBookingsForSchedule.fulfilled, (state, action) => {
      state.activeScheduleBookings = action.payload;
    });
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = activeBookingsSlice;
// Extract and export each action creator by name
export { actions as activeBookingsActions };
// Export the reducer, either as a default or named export
export default reducer;
